const SOUND_BASE = `${process.env.PUBLIC_URL || ''}/sounds/ludo/`;

const MINES_SOUNDS = {
  crash: {
    file: 'Crash-sound.mp3',
    volume: 1,
    maxMs: 2500,
  },
  safeClick: {
    file: 'Mines-click.mp3',
    volume: 1,
    maxMs: 800,
  },
  winning: {
    file: 'Winning.mp3',
    volume: 1,
    maxMs: 4000,
  },
};

const preloaded = new Map();

function soundUrl(key) {
  return `${SOUND_BASE}${MINES_SOUNDS[key].file}`;
}

function preload(key) {
  const url = soundUrl(key);
  if (!preloaded.has(url)) {
    const audio = new Audio(url);
    audio.preload = 'auto';
    preloaded.set(url, audio);
  }
  return preloaded.get(url);
}

/** Prime audio on first user gesture (mobile browsers). */
export function unlockMinesAudio() {
  Object.keys(MINES_SOUNDS).forEach((key) => {
    try {
      preload(key).load();
    } catch {
      /* ignore */
    }
  });
}

function playMinesSound(key) {
  unlockMinesAudio();

  const { volume, maxMs } = MINES_SOUNDS[key];
  const audio = new Audio(soundUrl(key));
  audio.volume = volume;

  const stop = () => {
    audio.pause();
    audio.currentTime = 0;
  };

  audio.play().catch(stop);
  window.setTimeout(stop, maxMs);
}

export function playMineCrash() {
  playMinesSound('crash');
}

export function playMineSafeClick() {
  playMinesSound('safeClick');
}

export function playMineWin() {
  playMinesSound('winning');
}
